// A ticket failed to print. The charge already went through, so the copy
// reassures the visitor and offers a retry plus "call staff".

import { Banner } from "../components/Banner";
import { Button } from "../components/Button";
import { WrenchMark } from "../components/Illustrations";
import { KioskShell } from "../components/KioskShell";
import { useLang } from "../i18n/LangContext";
import type { KioskState } from "../state/types";
import type { Dispatch } from "./shared";

type PrintError = Extract<KioskState, { phase: "print-error" }>;

export function PrintErrorScreen({
  state,
  dispatch,
}: {
  state: PrintError;
  dispatch: Dispatch;
}) {
  const { t } = useLang();
  const total = state.tickets.length;
  return (
    <KioskShell step={4}>
      <div className="screen screen--center">
        <div className="status-badge status-badge--warn badge-pop">
          <WrenchMark />
        </div>
        <h1 className="screen__title">{t("printErrorTitle")}</h1>
        <Banner variant="error">{state.error}</Banner>
        <p className="screen__note">
          {t("printErrorStatus", { done: state.printedCount, total })}
        </p>
        <p className="screen__note">{t("printErrorReassure")}</p>
        <div className="screen__actions">
          <Button
            onClick={() =>
              dispatch({
                type: "print-progress",
                printedCount: state.printedCount,
              })
            }
            size="lg"
          >
            {t("retryPrint")}
          </Button>
          <Button onClick={() => dispatch({ type: "reset" })} variant="danger">
            {t("callStaff")}
          </Button>
        </div>
      </div>
    </KioskShell>
  );
}
